import { render, staticRenderFns } from "./generic-sidebar.vue?vue&type=template&id=db1db568&scoped=true"
import script from "./generic-sidebar.vue?vue&type=script&lang=js"
export * from "./generic-sidebar.vue?vue&type=script&lang=js"
import style0 from "./generic-sidebar.vue?vue&type=style&index=0&id=db1db568&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1db568",
  null
  
)

export default component.exports